import { TableColumnMeta } from "ds/components/Table/types";

export const PROVIDER_VERSION_ARTIFACTS_TABLE_STORAGE_KEY =
  "providerVersionArtifactsTableStorageKey";

export enum PROVIDER_VERSION_ARTIFACTS_COLUMN_ID {
  NAME = "NAME",
  SIZE = "SIZE",
  DOWNLOAD = "DOWNLOAD",
}

const MAX_CELL_WIDTH = 600;

export const PROVIDER_VERSION_ARTIFACTS_TABLE_COLUMNS_CONFIG: Record<
  PROVIDER_VERSION_ARTIFACTS_COLUMN_ID,
  TableColumnMeta
> = {
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.NAME]: {
    id: PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 200,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: false,
    configurable: true,
  },
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.SIZE]: {
    id: PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.SIZE,
    title: "Size",
    minWidth: 80,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.DOWNLOAD]: {
    id: PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.DOWNLOAD,
    title: "Download artifact",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    allowsSorting: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<PROVIDER_VERSION_ARTIFACTS_COLUMN_ID, string> = {
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.NAME]: "name",
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.SIZE]: "size",
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.DOWNLOAD]: "download",
};
